module.exports = __webpack_public_path__ + "images/interview-Glassdoor-2.svg";